import React from "react"
import cx from "classnames"
import { AvatarSize } from "./types"

type AvatarImageProps = {
  src: string
  alt?: string
  className?: string
  size?: AvatarSize
}

const AvatarImage = ({
  src,
  alt,
  className,
  size = "sm"
}: AvatarImageProps) => {
  const SIZE_CLASSES = {
    sm: "w-6 h-6",
    lg: "w-10 h-10"
  }

  return (
    <div
      className={cx(
        SIZE_CLASSES[size],
        "rounded-full flex items-center justify-center overflow-hidden",
        className
      )}
    >
      <img
        src={src}
        alt={alt || "Avatar"}
        className="w-full h-full object-cover"
      />
    </div>
  )
}

export default AvatarImage
